import * as core from '@spyglassmc/core';
import * as json from '@spyglassmc/json';
/**
 * @returns An array of URIs corresponding to the specified resource.
 */
export function getUris(category, id, ctx) {
    return (ctx.symbols.query(ctx.doc, category, core.ResourceLocation.lengthen(id)).symbol
        ?.definition?.map((v) => v.uri) ?? []);
}
export function getTagValues(category, id, ctx) {
    const resolveValueNode = (node) => json.JsonStringNode.is(node)
        ? node.value
        : node.children.find((n) => n.key?.value === 'id').value.value;
    const set = getUris(category, id, ctx).reduce((ans, uri) => {
        // const result = ctx.getDocAndNode(uri)
        const result = undefined; // FIXME: Use global symbol table to get the result
        if (!result || result.node.parserErrors.length || result.node.checkerErrors?.length) {
            return ans;
        }
        // No errors in the node. We can assume it is a semantically correct tag file.
        const rootNode = result.node.children[0];
        const replaceNode = rootNode.children.find((n) => n.key?.value === 'replace')?.value;
        const valuesNode = rootNode.children.find((n) => n.key?.value === 'values')
            ?.value;
        const replace = replaceNode?.value;
        const values = valuesNode.children.map((n) => core.ResourceLocation.lengthen(resolveValueNode(n.value)));
        if (replace) {
            ans = new Set();
        }
        for (const value of values) {
            ans.add(value);
        }
        return ans;
    }, new Set());
    return [...set];
}
//# sourceMappingURL=index.js.map